const userCenter = {
  tab_profile: '个人信息',
  tab_security: '账号安全',
  tab_orders: '订购记录',
  profile_saved: '个人信息已保存',
  password_mismatch: '两次输入的新密码不一致',
  password_updated: '密码已更新',
  order_detail_pending: '订购详情（待对接）',
  basic_info: '基本信息',
  org_id: '组织 ID',
  phone: '手机号',
  phone_required: '请输入手机号',
  phone_invalid: '请输入正确的手机号',
  platform_email: '平台邮箱',
  wowbit_assigned: 'Wowbit 分配',
  plan_section: '当前套餐',
  addon_section: '独立权益包',
  addon_shop: '店铺加量槽位',
  addon_shop_unit: '个',
  addon_dm: '私信',
  addon_invite: '邀约',
  addon_mail: '邮件',
  addon_remain_before: '剩余',
  addon_remain_after: '',
  addon_load_failed: '独立权益包加载失败',
  current_plan: '当前套餐',
  expire_remain: '有效期至 {{date}} · 剩余 {{days}} 天',
  go_renew: '前往续费',
  go_upgrade: '立刻升级',
  renew_pending: '前往续费（待对接）',
  shop_slots: '店铺槽位',
  shop_total: '共 {{count}} 个',
  shop_used: '{{used}} / {{limit}} 个',
  addon: '加购',
  addon_shop_pending: '加购店铺槽位（待对接）',
  email_quota: '邮件额度',
  unlimited: '不限',
  email_total: '共 {{total}} 封/月',
  email_used: '{{used}} / {{limit}} 封',
  addon_email_pending: '加购邮件额度（待对接）',
  save_changes: '保存修改',
  change_password: '修改密码',
  login_methods: '登录方式',
  unbind: '解绑',
  change: '换绑',
  bind: '绑定',
  bind_phone_title: '绑定手机号',
  bind_email_title: '绑定登录邮箱',
  bind_confirm: '确认绑定',
  bind_hint: '验证码将发送至该联系方式。绑定后可用其登录。',
  bind_success: '已绑定',
  bind_failed: '绑定失败',
  bind_phone_placeholder: '请输入手机号',
  bind_email_placeholder: '请输入登录邮箱',
  unbind_phone_title: '解绑手机号',
  unbind_email_title: '解绑登录邮箱',
  unbind_confirm: '确认解绑',
  unbind_hint: '验证码将发送至该联系方式。解绑后将无法再用其登录，请确保账号仍保留其他登录方式。',
  unbind_code_invalid: '请输入 6 位数字验证码',
  unbind_identity_missing: '缺少可解绑的联系方式',
  unbind_success: '已解绑',
  unbind_failed: '解绑失败',
  unbind_unavailable: '暂无可解绑的联系方式',
  change_phone_title: '换绑手机号',
  change_email_title: '换绑登录邮箱',
  change_confirm: '确认换绑',
  change_hint: '请分别向旧、新联系方式获取 BINDING 验证码后再提交。',
  change_old_identity: '当前联系方式',
  change_old_code: '旧联系方式验证码',
  change_new_identity: '新联系方式',
  change_new_code: '新联系方式验证码',
  change_phone_placeholder: '请输入新手机号',
  change_email_placeholder: '请输入新登录邮箱',
  change_email_invalid: '请输入正确的邮箱',
  change_same_identity: '新联系方式不能与当前相同',
  change_success: '已换绑',
  change_failed: '换绑失败',
  current_password: '当前密码',
  current_password_required: '请输入当前密码',
  new_password: '新密码',
  new_password_required: '请输入新密码',
  password_rule: '至少 8 个字符，不能包含空格，且 UTF-8 不超过 72 字节',
  current_password_rule: '当前密码不超过 72 个字符，且 UTF-8 不超过 72 字节',
  password_change_failed: '密码修改失败',
  password_changed_relogin: '密码已更新，请重新登录',
  strength: '密码强度：{{level}}',
  strength_weak: '弱',
  strength_mid: '中',
  strength_strong: '强',
  confirm_password: '确认新密码',
  confirm_password_required: '请再次输入新密码',
  order_packages: '套餐订购',
  order_benefits: '独立权益订购',
  col_order_no: '订单号',
  col_package: '套餐',
  col_amount: '金额',
  col_status: '状态',
  col_purchased_at: '购买时间',
  col_actions: '操作',
  status_completed: '已完成',
  status_pending: '待支付',
  status_cancelled: '已取消',
  orders_load_failed: '订购记录加载失败',
  fulfillment_PENDING: '待发放',
  fulfillment_FULFILLED: '已发放',
  fulfillment_MANUAL_REVIEW: '待处理',
  order_days: '{{days}} 天'
};

export default userCenter;
